import { render, staticRenderFns } from "./CalendarToggleSlot.vue?vue&type=template&id=03867882"
import script from "./CalendarToggleSlot.vue?vue&type=script&lang=js"
export * from "./CalendarToggleSlot.vue?vue&type=script&lang=js"
import style0 from "./CalendarToggleSlot.vue?vue&type=style&index=0&id=03867882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports